export default {
    name: 'LandingPageMobileDisplay',
    props: {
        imageName: {
            type: String, // only file name and extension inside the assests folder
            required: true
        },
        isPrimaryImage: {
            type: Boolean,
            default: false
        },
        hasBoxShadow: {
            type: Boolean,
            default : true
        },
        hasDescriptionCard: {
            type: Boolean,
            default: false
        },
        descriptionOnly: {
            type: Boolean,
            default: false
        },
        description: {
            type: String
        },
        lighterCardColor: {
            type: Boolean,
            default: false
        }
    }
}